import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import Login from '../Screens/Login';
 import NoRoute from '../Screens/NoRoute';

import asyncComponent from '../asyncComponent';

import Coach from '../Screens/Coach';
import Users from '../Screens/Users';
import ThinkTool from '../Screens/ThinkTool';
import Versions from '../Screens/Versions';
import LearnerThinkTool from '../Screens/LearnerThinkTool';
import CoachProgrammesList from './CoachProgrammesList';
import CoachProgrammesListSmall from './CoachProgrammesListSmall';
import Rollouts from '../Screens/Rollouts';
import CoachRolloutList from './CoachRolloutList';
import CoachProjectsList from './CoachProjectsList';
// import Assessments from '';

// const Assessments = asyncComponent(() =>
//     import('../Screens/Assessments').then(module => module.default)
// )
// const Login = asyncComponent(() =>
//     import('../Screens/Login').then(module => module.default)
// )
// const LearnerThinkTool = asyncComponent(() =>
//     import('../Screens/LearnerThinkTool').then(module => module.default)
// )
// const TeamLeaderThinkTool = asyncComponent(() =>
//     import('../Screens/TeamLeaderThinkTool').then(module => module.default)
// )
// const TeamLeader = asyncComponent(() =>
//     import('../Screens/TeamLeader').then(module => module.default)
// )
// const Learner = asyncComponent(() =>
//     import('../Screens/Learner').then(module => module.default)
// )
// const Module = asyncComponent(() =>
//     import('../Screens/Modules').then(module => module.default)
// )

// const Content = asyncComponent(() =>
//     import('../Screens/Content').then(module => module.default)
// )
// const Report = asyncComponent(() =>
//     import('../Screens/Report').then(module => module.default)
// )

// const Tools = asyncComponent(() =>
//     import('../Screens/Tools').then(module => module.default)
// )

const Routes = () => (
  <Switch>
     <Route
      path="/users/:projectId/:rolloutId/:userId/:thinktoolid/:versionid" exact
      component={LearnerThinkTool}
    />
    <Route path="/team-leader" component={Coach} />
    <Route path="/users/:projectId/:rolloutId" exact component={Users} />
    <Route path="/rollouts/:projectId" exact component={Rollouts} />
    <Route path="/projects" exact component={CoachProjectsList} />
    <Route path="/users/:projectId/:rolloutId/:userId" exact component={ThinkTool} />
    <Route path="/users/:projectId/:rolloutId/:userId/:thinktoolid" exact component={Versions} />
    <Route path="/login" component={Login} />
    <Route path="/" exact component={Login} />
    <Route component={NoRoute} />
  </Switch>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/Components/Routes.jsx